// Ajax cart JS Cart Page

class AjaxCart extends HTMLElement {
  constructor() {
    super();

    this.bindEvents();
    this.style.visibility = 'visible';

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    let removeGwpSampleElement = document.querySelector('[data-gwp-free-sample-remove]');
    let removeSampleElement = document.querySelector('[data-free-sample-remove]');
    this.AddSampleElement = document.querySelector('[data-add-free-sample]');
    this.free_knife_discount_form = this.querySelector("#free-knife-discount-form") ?? null;
    this.free_knife_discount_form?.addEventListener('submit', this.onDiscountFormSubmitHandler.bind(this));
    
    setTimeout(() => {
      if (typeof(this.AddSampleElement) != 'undefined' && this.AddSampleElement != null && document.querySelector(`[data-variant-id="${window.globalVariables.free_product_var_id}"]`) == null && !window.globalVariables.discount_code_based_free_knife) {
        var getSampleIds = this.AddSampleElement.getAttribute('data-add-free-sample');
        this.AddSampleProducts(getSampleIds);
      }
    
      if (typeof(removeSampleElement) != 'undefined' && removeSampleElement != null){
          var getSampleIds = removeSampleElement.getAttribute('data-free-sample-remove');
          this.removeSampleProducts(getSampleIds);
      }
  
      if (typeof(removeGwpSampleElement) != 'undefined' && removeGwpSampleElement != null){
        var getGwpSampleIds = removeGwpSampleElement.getAttribute('data-gwp-free-sample-remove');
        this.removeSampleProducts(getGwpSampleIds);
      }

      
    }, 1000);


    setTimeout(() => {
      this.addOnProduct = this.querySelector('[data-addOn-product]') ?? null;
      console.log("Test: ", this.addOnProduct)
      this.addOnProduct && this.handleAddOnProduct();
    }, 2000);
    

  }

  AddSampleProducts(ids){
    var getAllVarId = [];
  
      getAllVarId.push({id: ids, quantity: 1, properties:{
        "product_type":"free"
      }});

    
    var body = { items: getAllVarId }; 

    const result = fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(body) 
    }).then(response => {

        this.getCartData();
    }).catch(err => {
      Rollbar.error(`File: Compoment-ajax-cart.js,function - AddSampleProducts Add sample product product issue found!: ${err}`);
    })
    
}

  removeSampleProducts(ids){
    
    var varArray = ids.split(',');
    var data = {};
   
    for (let index = 0; index < varArray.length; ++index) {
        data[varArray[index]] = 0;
        
        if(index == varArray.length-1){
            const result = fetch("/cart/update.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({updates: data}) 
            }).then(response => {
              this.getCartData();
            }).catch(err => {
              Rollbar.error(`File: Compoment-ajax-cart.js,function - removeSampleProducts remove sample product product issue found!: ${err}`);
            })
        }
    }
    
}

onDiscountFormSubmitHandler(evt) {
  try {
    evt.preventDefault();
    let formData = null;
    formData = JSON.parse(serializeForm(this.free_knife_discount_form));
    this.free_knife_discount_form.querySelector('button[type="submit"]').classList.add('loading');
    if (formData.discountcode.toLowerCase() == window.globalVariables.gwp_tier1_discount_code.toLowerCase()) {
      this.querySelector("[data-freeKnifeDiscountFormErrors]").classList.add('d-none');
      if (typeof(this.AddSampleElement) != 'undefined' && this.AddSampleElement != null && document.querySelector(`[data-variant-id="${window.globalVariables.free_product_var_id}"]`) == null){
        var getSampleIds = this.AddSampleElement.getAttribute('data-add-free-sample');
        this.AddSampleProducts(getSampleIds);
      } else {
        this.querySelector("[data-freeKnifeDiscountFormErrors]").classList.remove('d-none');
      }
    } else {
      this.querySelector("[data-freeKnifeDiscountFormErrors]").classList.remove('d-none');
    }
    setTimeout(() => {
      this.free_knife_discount_form.querySelector('button[type="submit"]').classList.remove('loading');
    }, 200);
    this.free_knife_discount_form.reset();
  } catch (error) {
    Rollbar.error(`File: Compoment-ajax-cart.js, onDiscountFormSubmitHandler issue: ${error}`);
  }
}

  /**
   * Observe attribute of component
   * 
   * @returns {array} Attributes to Observe
   */
  static get observedAttributes() {
    return ['updating'];
  }

  /**
   * To Perform operation when attribute is changed
   * Calls attributeChangedCallback() with params when attribute value is updated
   * 
   * @param {string} name attribute name
   * @param {string} oldValue attribute Old value
   * @param {string} newValue attribute latest value
   */
  attributeChangedCallback(name, _oldValue, newValue) {
    // called when one of attributes listed above is modified
    if(name == 'updating' && newValue == 'false'){
      this.updateEvents();
    }
  }


  /**
   * bind Other inside element events
   *
   */
  bindEvents() {
    this.updateEvents();
  }

  /**
   * bind Other inside element events to DOM
   *
   */
  updateEvents(){
    this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
    this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
  }

  /**
   * Update cart HTML 
   *
   * @param {string} cartHTML String formatted response from fetch cart.js call
   */
  _updateCart(response, action){
    this.setAttribute('updating', true);

    // Convert the HTML string into a document object
    let cartHTML = response['template-cart'];

    if(cartHTML == null) return;
    let parser = new DOMParser();
    cartHTML = parser.parseFromString(cartHTML, 'text/html');

    let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
    if(cartJSONEle != undefined && cartJSONEle != null){
      window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
    }

    let cartElement = cartHTML.querySelector('ajax-cart form');
    if(this.querySelector('form')){ this.querySelector('form').innerHTML = cartElement.innerHTML; }
    if(this.querySelector('[data-carttotal] span.money')){ 
      this.querySelector('[data-carttotal] span.money').innerHTML = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
    }
   
    let removeSampleElement = document.querySelector('[data-free-sample-remove]');
    if (typeof(removeSampleElement) != 'undefined' && removeSampleElement != null){
      var getSampleIds = removeSampleElement.getAttribute('data-free-sample-remove');
      this.removeSampleProducts(getSampleIds);
    }

    let removeGwpSampleElement = document.querySelector('[data-gwp-free-sample-remove]');
    if (typeof(removeGwpSampleElement) != 'undefined' && removeGwpSampleElement != null){
      var getGwpSampleIds = removeGwpSampleElement.getAttribute('data-gwp-free-sample-remove');
      this.removeSampleProducts(getGwpSampleIds);
    }

    let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartupsell], [data-freeKnifeDiscountForm]');
    if(window.globalVariables.cart.item_count <= 0){
      elements.forEach((div)=>{
        div.classList.add('d-none');
      });
    }else{
      elements.forEach((div)=>{
        div.classList.remove('d-none');
      });
    }
    this.setAttribute('updating', false);

    let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
    let desktopCartIcon = headerHTML.getElementById('cart-icon-desktop');
    let mobileCartIcon = headerHTML.getElementById('cart-icon-mobile');
    let desktopCartIconTarget = document.querySelector('#cart-icon-desktop');
    let mobileCartIconTarget = document.querySelector('#cart-icon-mobile');

    if (desktopCartIconTarget && desktopCartIcon) {
      desktopCartIconTarget.innerHTML = desktopCartIcon.innerHTML;
    }

    if (mobileCartIconTarget && (mobileCartIcon || desktopCartIcon)) {
      mobileCartIconTarget.innerHTML = (mobileCartIcon || desktopCartIcon).innerHTML;
    }

    this.syncCartCounter();

    let cartItems = window.globalVariables.cart.items;
    cartItems.forEach((item,index) => {
      if(item.quantity != 1 && window.globalVariables.cart.item_count > 1 && item.properties.product_type == 'free' || item.properties.product_type == 'gwp_free'){
        let itemIndex = index + 1;
        if(itemIndex != null){
            this.updateItemQtyOld(itemIndex, 1);
          setTimeout(function(){
            location.reload();
          },400)
        }
      }
    });

    setTimeout(() => {
      this.addOnProduct = this.querySelector('[data-addOn-product]') ?? null;
      console.log("Test: ", this.addOnProduct)
      this.addOnProduct && this.handleAddOnProduct();
    }, 2000);
  }

  syncCartCounter() {
    const cartCount = Number(window.globalVariables?.cart?.item_count) || 0;
    const cartIcons = document.querySelectorAll('#cart-icon-desktop, #cart-icon-mobile');

    cartIcons.forEach((cartIcon) => {
      if (!cartIcon) return;

      let cartCountElement = cartIcon.querySelector('.cart-count');
      if (cartCount > 0 && cartCount < 100) {
        if (!cartCountElement) {
          cartCountElement = document.createElement('span');
          cartCountElement.className = 'cart-count';
          cartCountElement.setAttribute('aria-hidden', 'true');
          cartIcon.appendChild(cartCountElement);
        }
        cartCountElement.textContent = cartCount;
      } else if (cartCountElement) {
        cartCountElement.remove();
      }
    });
  }

  /**
   * Fetch latest cart data 
   */
  getCartData(action){
      let cartRoute = `${routes.cart_fetch_url}?sections=template-cart,header`;

      fetch(cartRoute).then(response => {
        return response.json();
      }).then(response => {
          this._updateCart(response, action);
      }).catch((e) => {
          console.error(e);
          Rollbar.error(`File: Compoment-ajax-cart.js, getting issue in fetching cart data in getCartData: ${error}`);
      }).finally(() => {
          // Cart HTML fetch done
      });
  }

   /**
   * Update Quantity API call 
   *
   * @param {string} line Line Index value of cart Item (Starts from 1)
   * @param {integer} quantity Quantity to update
   */
  updateItemQty(line, quantity){
      let lineItem = document.querySelector(`[data-cart-item="${line}"]`);

      if(lineItem){ lineItem.classList.add('updating'); }
      // const body = JSON.stringify({
      //     line,
      //     quantity
      // });

      var body = {};
      body[line] = quantity;
      body = JSON.stringify({updates: body});
      console.log("body", body);

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }})
      .then((response) => {
          return response.text();
      })
      .then((_state) => {
        this.getCartData();
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 1000);
      }).catch((error) => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 1000);
        console.log(error);
        Rollbar.error(`File: Compoment-ajax-cart.js, getting error in update item quantity for updateItemQty: ${error}`);
      });
  }

  updateItemQtyOld(line, quantity){
    let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

    if(lineItem){ lineItem.classList.add('updating'); }
    const body = JSON.stringify({
        line,
        quantity
    });


    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
    .then((response) => {
        return response.text();
    })
    .then((_state) => {
      this.getCartData();
      setTimeout(() => {
        if(lineItem){ lineItem.classList.remove('updating'); }
      }, 1000);
    }).catch((error) => {
      setTimeout(() => {
        if(lineItem){ lineItem.classList.remove('updating'); }
      }, 1000);
      console.log(error);
      Rollbar.error(`File: Compoment-ajax-cart.js, getting error in update item quantity for updateItemQtyOld: ${error}`);
    });
  }

  /**
   * Remove Item Event
   *
   * @param {event} Event instance
   */
  removeItem(event){
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex != null){
          this.updateItemQty(itemIndex, 0);
      }
    } catch (error) {
      Rollbar.error(`File: Compoment-ajax-cart.js, getting error in removeItem: ${error}`);
    }
  }

  /**
   * Cart Item Qunatity Increment/Decrement Button event
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event){
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;

      if(action == 'decrease' && currentQty <= 1){
          return false;
      }else if(action == 'decrease'){
          finalQty = currentQty - 1;
      }else{
          finalQty = currentQty + 1;
      }
      this.updateItemQty(itemIndex, finalQty);
    } catch (error) {
      Rollbar.error(`File: Compoment-ajax-cart.js, getting issue in manageQtyBtn: ${error}`);
    }
  }

  /**
   * Cart Item Qunatity Input change event
   *
   * @param {event} Event instance
   */
  onQtyChange(event){
    const $qtyInput = event.currentTarget;
    const qtyValue = $qtyInput.value;
    const itemIndex = $qtyInput.dataset.index || null;
    if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
  }

  /**
   * fade effect on reponse
   * @param {element} element 
   */
  manageResponseText(element){
    Utility.fadeEffect(element, 'fadeIn');
    setTimeout(() => {
        Utility.fadeEffect(element, 'fadeOut');
    }, 3000);
  }

  /**
   * handle AddOn Product
  **/
  handleAddOnProduct(){
    let addOnProducts = this.querySelectorAll('[data-addon-product]');
    let addOnKey = null;
    let addOnKeys = {};
    let parentProductInCart = null;
    if(addOnProducts.length > 0) {
      addOnProducts.forEach((addOn) => {
        let parentProduct = addOn.dataset.parentProduct;
        parentProductInCart = this.querySelector(`[data-variant-id="${parentProduct}"]`) ?? null;
        addOnKey = addOn.dataset.cartItem;
        addOnKeys[addOnKey] = 0;
        !parentProductInCart && addOn.classList.add('updating');
      })
      if(!parentProductInCart) {
        this.querySelector('#cartCheckout').classList.add('disabled');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: addOnKeys
          })
        }).then(response => response.json())
          .then((newCart) => {
            this.getCartData();
            this.querySelector('#cartCheckout').classList.remove('disabled');
          })
          .catch(console.error("Product not found or unexpected error occur."))
      }
    }
  }
}
customElements.define("ajax-cart", AjaxCart);